// @ts-check
/**
 * @typedef {Object} FfDrawerCustomProperties
 * @property {() => Promise<void>} ffOpen Opens drawer
 * @property {(enable: boolean) => void} enable If true removes disable attribute
 * @property {() => Promise<void>} ffInit Adds click event for submit and close drawer
 * @property {() => Promise<void>} ffClose Closes drawer
 * @property {() => Promise<void>} ffToggle Opens or closes drawer according to ffIsOpen
 * @property {Boolean} ffIsOpen Drawer open status
 *
 * @typedef {FfDrawerCustomProperties & HTMLElement} FfDrawer
 */
class FfDrawer extends HTMLElement {
  constructor() {
    super();

    this.ffInit(true);

    document
      .querySelectorAll("[data-ff-closer-drawer-id='" + this.id + "']")
      .forEach((drawerCloserEl) => {
        drawerCloserEl.addEventListener("click", this.ffClose);
      });

    document
      .querySelectorAll("[data-ff-opener-drawer-id='" + this.id + "']")
      .forEach((drawerCloserEl) => {
        drawerCloserEl.addEventListener("click", this.ffOpen);
      });
  }

  ffToggle = (e) => {
    if (this.ffIsOpen == true) {
      this.ffClose();
    } else {
      this.ffOpen();
    }
  };

  ffOpenCloseAction = () => {};

  ffOpen = () => {
    const windowHeight = window.innerHeight;
    this.ffIsOpen = true;
    document.body.classList.add("ff-overflow-hidden", "ff-drawer-active");
    document.body.dataset.ffDrawerActive = this.id;
    this.style.display = "";
    const drawerContent =
      this.ffDrawerContent?.querySelector(".ff-drawer_content");
    if (drawerContent) {
      drawerContent.style.height = "100%";
      this.ffOpenCloseAction = () => {
        this.style.setProperty(
          "--ff-drawer-content-height",
          drawerContent?.scrollHeight + "px"
        );
        drawerContent.style.height = "";
      };
    } else {
      this.ffOpenCloseAction = () => {};
    }
    const { top } = this.getBoundingClientRect();
    const drawerHeight = windowHeight - top;
    this.style.setProperty("--ff-drawer-height", drawerHeight + "px");
    this.classList.add("ff-drawer-open");
    requestAnimationFrame(() => {});
    //@ts-ignore
    const { offsetLeft, offsetWidth } = this.querySelector(
      "#ff-drawer-container-dimensions"
    );
    this.style.setProperty(
      "--ff-drawer-container-dimension-left",
      offsetLeft + "px"
    );
    this.style.setProperty(
      "--ff-drawer-container-dimension-width",
      offsetWidth + "px"
    );
  };

  ffClose = () => {
    this.ffIsOpen = false;
    this.ffOpenCloseAction = () => {
      this.style.display = "none";
      document.body.classList.remove("ff-overflow-hidden", "ff-drawer-active");
      document.body.dataset.ffDrawerActive = "";
    };
    this.classList.remove("ff-drawer-open");
  };

  /**
   *
   * @param {boolean} drawerContentReplaced
   */
  ffInit(drawerContentReplaced = false) {
    //drawer content has class 'ff-drawer-container' which has the transition
    this.ffDrawerContent = this.querySelector("[data-ff-drawer-content]");

    if (drawerContentReplaced) {
      this.querySelector("[data-ff-drawer-closer-updatable]")?.addEventListener(
        "click",
        this.ffClose
      );

      this.ffDrawerContent?.addEventListener("transitionend", (e) => {
        if (e.target == this.ffDrawerContent) {
          this.ffOpenCloseAction();
        }
      });
    }
  }
}

if (!customElements.get("ff-drawer")) {
  customElements.define("ff-drawer", FfDrawer);
}
